import React, { ReactElement } from "react"
import { Typography } from "@carrotfertility/carotene-core"
import { useFlags } from "launchdarkly-react-client-sdk"

export function JourneyChange(): ReactElement {
  const isMemberEnrolled = false
  const isMemberEngaged = false

  return (
    <>
      {isMemberEnrolled && <PreCarrotPlanJourneyChange />}
      {isMemberEngaged && <PostCarrotPlanJourneyChange />}
    </>
  )
}

export const LaunchDarklyJourneyChangeContainer = ({ children }: { children: ReactElement }): ReactElement => {
  const { journeySelectionHomePageDisplay } = useFlags()

  if (!journeySelectionHomePageDisplay) {
    return null
  }

  return children
}

function PreCarrotPlanJourneyChange(): ReactElement {
  // eslint-disable-next-line formatjs/no-literal-string-in-jsx
  return <Typography>PreCarrotPlanJourneyChange</Typography>
}

function PostCarrotPlanJourneyChange(): ReactElement {
  // eslint-disable-next-line formatjs/no-literal-string-in-jsx
  return <Typography>PostCarrotPlanJourneyChange</Typography>
}
